import
  React
from 'react';

import {
  BrowserRouter,
  HashRouter,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

import { ErrorBoundary } from "react-error-boundary";

import { HelmetProvider } from 'react-helmet-async';

/*import {
  isValidProviderResult,
} from 'common';*/

import {
  Logger
} from 'common';

import {
  ShareMeta,
} from 'common/components';

import {
  WidgetProvider
} from './common/contexts';

import {
  Routes,
} from 'navigation';

/*import {
  VersionProvider,
} from 'providers';*/

function App({ widget }) {

  /*React.useEffect(() => {

    VersionProvider
      .getLatestVersion()
      .then(ret => {

        if (!isValidProviderResult(ret)) {
        
          // TODO: log to sentry
          return;
        }
      })

  }, []);*/

  let routes = [];
  let route;

  for (const key in Routes) {

    route = Routes[key];

    if (route.default) {

      routes.push(
        <Route exact path={'/'} key={'default-path'}>
          <Redirect to={route.path} />
        </Route>
      );
    }

    routes.push(
      <Route
        key={key}
        component={route.component}
        path={route.path}
        exact={true}
      />
    );
  }

  const Router = widget ? HashRouter : BrowserRouter;

  return (

    <HelmetProvider>
      {!widget && (
        <ShareMeta
          url="https://weticket.co.za/"
          image="https://weticket.co.za/favicon.png">
          <meta name="robots" content="index, follow" />
          <meta name="author" content="WeTicket" />
          <meta name="geo.region" content="ZA" />
          <meta name="geo.placename" content="South Africa" />
          <meta name="keywords" content="weticket, WeTicket, we ticket, wetickets, event tickets, buy tickets online, concerts, festivals, ticket booking, ticket sales, weticket.co.za" />
        </ShareMeta>
      )}
      <WidgetProvider widget={widget}>
        <ErrorBoundary fallback={<div></div>} onError={(error, info) => Logger.error('ErrorBoundary', 'ErrorBoundary', error)}>
          
          <Router>

            <Switch>
              {routes}
            </Switch>

          </Router>

        </ErrorBoundary>
      </WidgetProvider>
    </HelmetProvider>
  );
}

export default App;
